import axios from '@axios';
import { AxiosPromise } from 'axios';
import qs from 'qs';

const API_URL = '/news';

export async function getNews(documentId: string): AxiosPromise {
    const query = {
        populate: ['image', 'tags', 'mainTag'],
        filters: {
            $or: [
                {
                    slug: documentId,
                },
                {
                    documentId,
                },
            ],
        }
    };
    return axios.get(`${API_URL}?${qs.stringify(query)}`);
}

export async function getNewsByTag({ tag, limit = 2, documentId }: { tag: string; limit: number; documentId: string }): AxiosPromise {
    const query = {
        populate: ['image', 'tags', 'mainTag'],
        filters: {
            tags: {
                slug: tag,
            },
            documentId: {
                $not: documentId,
            },
        },
        pagination: {
            pageSize: limit,
        },
        sort: ['publishDate:desc'],
    };
    return axios.get(`${API_URL}?${qs.stringify(query)}`);
}

export async function getNewsPage(): AxiosPromise {
    return axios.get(`/news-page-content`);
}
